import { IShop } from "src/domain/entities"
import { shopListApi } from "../../api/shop/shopListApi"

type PayloadShape = Parameters<typeof shopListApi>[0]

export async function shopListService(payload: PayloadShape, token?: null | string) {
	const shop = await shopListApi(payload, token)
	return shop as NonNullable<IShop[]>
}
